import Types from "./Types";

const INITIAL_STATE = {
  userData: {},
  notifications: [],
  isLoading: false,
  groups: [],
};

export default function user(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_USER_DATA_SUCCESS: {
      const roleName = payload.data?.role?.[0]?.name;
      if (roleName) window.localStorage.setItem("user_role", roleName);
      return {
        ...state,
        userData: payload.data,
      };
    }
    case Types.GET_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        notifications: payload.data,
      };
    }

    case Types.GET_USER_GROUPS_SUCCESS: {
      return {
        ...state,
        groups: payload.data,
      };
    }

    // Misc
    case Types.SET_USER_IS_LOADING: {
      const isLoading = payload;
      return {
        ...state,
        isLoading: isLoading,
      };
    }

    default: {
      return state;
    }
  }
}
